/** Fictional brands: examples only. */
export const SAMPLE_BRANDS = [
  { name: 'Studio Força', color: '#E4572E' },
  { name: 'Nutri Clara', color: '#0B7A75' },
  { name: 'Coach Rafa', color: '#5B2DB0' },
  { name: 'Pulse Training', color: '#C2185B' },
  { name: 'Vida Ativa', color: '#2E7D32' },
  { name: 'Treino Azul', color: '#1565C0' },
] as const;

export interface BrandState {
  name: string;
  color: string;
  radius: number;
}

export const DEFAULT_BRAND: BrandState = { ...SAMPLE_BRANDS[0], radius: 16 };
